import logo from '../../../assets/PNG/transparentLogo.png';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Form } from '@kuzmycz/react-form-ula';
import BioPlusTextField from '../../../Components/form-fields/BioPlusTextField';
import InvitationService from '../../../services/bioplus-services/invitation';
import {
  Layout,
  ContentWrapper,
  Gap,
  HeadingTitle,
  LogoContainer,
  ModalButtonWrapper,
  Wrapper,
  MessageTitle,
  LinkSpan,
} from './userInvitation.style';
import { Button } from '../../../Components/uielements';
import { ErrorSvg, SuccessSvg } from '../../../Components/icons';

export const getCountryCode = (env) => {
  switch (env) {
    case 'development':
    case 'stage':
    case 'production':
      return '+1';
    case 'au_development':
    case 'au_stage':
    case 'au_production':
      return '+61';
    default:
      return '+61';
  }
};

const UserInvitation = () => {
  const [searchParams] = useSearchParams();
  const { invitationId } = useParams();
  const navigate = useNavigate();
  const initial = {
    countryCode: getCountryCode(process.env.REACT_APP_ENV),
    invitationCode: searchParams.get('code'),
    invitationId,
  };
  const [status, setStatus] = useState('registering');
  const [message, setMessage] = useState();
  const [isDistributor, setIsDistributor] = useState(false);

  useEffect(() => {
    const checkInvitation = async () => {
      try {
        const response = await InvitationService.checkInvitation(invitationId);

        if (response?.role === 'PARTNER') {
          setIsDistributor(true);
        }

        if (response?.existing === 1) {
          navigate(`/user-invitations/${invitationId}?code=${searchParams.get('code')}`);
        }
      } catch (error) {
        console.error('Error checking invitation:', error);
      }
    };
    checkInvitation();
  }, [invitationId, navigate, searchParams]);

  const handleRetry = () => {
    setMessage(undefined);
    setStatus('registering');
  };

  const handleToLoginPage = () => {
    navigate('/');
  };

  const handleSubmit = async (values) => {
    try {
      setMessage(undefined);

      const response = isDistributor
        ? await InvitationService.distributorRegisterByInvitation(values)
        : await InvitationService.registerByInvitation(values);
      if (response) {
        setStatus('success');
      }
    } catch (e) {
      setMessage(e?.response?.data?.message);
      setStatus('error');
    }
  };

  if (status === 'success') {
    return <Success handleToLoginPage={handleToLoginPage} />;
  }

  if (status === 'error') {
    return <Error message={message} onRetry={handleRetry} />;
  }

  return (
    <Layout>
      <ContentWrapper>
        <LogoContainer>
          <img src={logo} style={{ width: 300 }} alt="Bioplus.logo" />
          <HeadingTitle>
            Member Registration <span>(by invitation)</span>
          </HeadingTitle>
        </LogoContainer>
        <Form initialValues={initial} onSubmit={handleSubmit}>
          <Wrapper>
            <Gap>
              <BioPlusTextField name={'email'} label={'Email'} />
              <BioPlusTextField name={'password'} label="Password" type="password" />
              <BioPlusTextField name={'firstName'} label={'First Name'} />
              <BioPlusTextField name={'lastName'} label={'Last Name'} />
              <BioPlusTextField name={'countryCode'} label={'Country Code'} />
              <BioPlusTextField name={'phone'} label={'Phone'} />
              {isDistributor && <BioPlusTextField name={'companyName'} label={'Entity Name'} />}
              {isDistributor && <BioPlusTextField name={'abn'} label={'ABN'} />}
              <ModalButtonWrapper>
                <Button type={'submit'}>Register</Button>
              </ModalButtonWrapper>
            </Gap>
          </Wrapper>
        </Form>
      </ContentWrapper>
    </Layout>
  );
};

const Success = ({ handleToLoginPage }) => (
  <Layout>
    <ContentWrapper>
      <LogoContainer>
        <img src={logo} style={{ width: 300 }} alt="Bioplus.logo" />
        <HeadingTitle>
          Member Registration <span>(by invitation)</span>
        </HeadingTitle>
      </LogoContainer>

      <MessageTitle>
        <SuccessSvg style={{ width: '100px', height: '100px' }} />
        Success! You have now registered. You can now log in via the app.
        <LinkSpan onClick={handleToLoginPage}>Click to Login</LinkSpan>
      </MessageTitle>
    </ContentWrapper>
  </Layout>
);

const Error = ({ message, onRetry }) => (
  <Layout>
    <ContentWrapper>
      <LogoContainer>
        <img src={logo} style={{ width: 300 }} alt="Bioplus.logo" />
        <HeadingTitle>
          Member Registration <span>(by invitation)</span>
        </HeadingTitle>
      </LogoContainer>
      <MessageTitle>
        <ErrorSvg style={{ width: '100px', height: '100px' }} />
        Error! Registration was unsuccessful.{' '}
        <ModalButtonWrapper>
          <Button onClick={onRetry}>Retry</Button>
        </ModalButtonWrapper>
      </MessageTitle>{' '}
    </ContentWrapper>
  </Layout>
);

export default UserInvitation;
